import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxTurnstileComponent, NgxTurnstileModule } from 'ngx-turnstile';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cloud-fare',
  standalone: true,
  imports: [CommonModule, NgxTurnstileModule],
  templateUrl: './cloud-fare.html',
})
export class CloudFareComponent {

  siteKey = environment.key_value;
  renderKey = 0; // 🔑 force re-render
  private resetAttempts = 0;
  private readonly MAX_RESET_ATTEMPTS = 3;
  private lastResetTime = 0;
  private readonly RESET_COOLDOWN = 5000; // 5 seconds

  @ViewChild('ts') turnstile!: NgxTurnstileComponent;

  @Output() tokenGenerated = new EventEmitter<string>();
  @Output() tokenInvalid = new EventEmitter<void>();

  token: string | null = null;
  showTurnstile = true;


  onExpired() {
    this.tokenInvalid.emit();
    // Don't reset, just notify that token is invalid
  }

  onError(error?: any) {
    this.resetAttempts++;
    
    // Only reset if we haven't exceeded max attempts and cooldown has passed
    if (this.resetAttempts <= this.MAX_RESET_ATTEMPTS && 
        Date.now() - this.lastResetTime > this.RESET_COOLDOWN) {
      this.reset();
    } else if (this.resetAttempts > this.MAX_RESET_ATTEMPTS) {
    }
  }

  onResolved(token: any) {
    this.token = token;
    this.resetAttempts = 0; // Reset counter on successful resolution

    this.tokenGenerated.emit(token);
  }

  public refreshToken(): void {
    this.resetAttempts = 0; // voluntary refresh resets error counter
    this.token = null;
    this.showTurnstile = false;

    queueMicrotask(() => {
      this.showTurnstile = true;
    });
  }

  private reset() {
  

    this.lastResetTime = Date.now();
    this.token = null;
    this.tokenInvalid.emit();

    this.showTurnstile = false;

    queueMicrotask(() => {
      this.showTurnstile = true;
    });
  }

}
